const { h, render, Component } = require('preact');
const ID = require('./id')
const PurchaseDate = require('./purchase_date')
const Status = require('./status')
const ExpiryDate = require('./expiry_date')
const Gift = require('./gift')
const Quantity = require('./quantity')

class LocalGoodsTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <table class="first-table">
        <ID orderDetails={this.props.orderDetails}/>
        <PurchaseDate orderDetails={this.props.orderDetails}/>
        <Status orderDetails={this.props.orderDetails}/>
        <ExpiryDate orderDetails={this.props.orderDetails}/>
        <Gift orderDetails={this.props.orderDetails}/>
        <Quantity orderDetails={this.props.orderDetails}/>
      </table>
    );
  }
}
module.exports = LocalGoodsTable
